// SessionManagement.jsx
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import logo from "../utils/assets/login-illustration.png"; // adjust path

const SessionManagement = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { token, otp, sessions } = location.state || {};

  const [sessionList, setSessionList] = useState([]);
  const [loadingId, setLoadingId] = useState(null);

  useEffect(() => {
    if (!token || !otp) {
      navigate("/user/sign_in", { replace: true });
      return;
    }

    if (Array.isArray(sessions)) {
      setSessionList(sessions);
    }
  }, []);

  /* ===========================
     LOGOUT SINGLE SESSION
  =========================== */
  const handleLogoutSession = async (SessionId) => {
    try {
      setLoadingId(SessionId);

      await axios.post(
        `${process.env.REACT_APP_API_URL}/user/delete-user-session`,
        {SessionId}
      );

      // Remove session from UI
      setSessionList((prev) =>
        prev.filter((s) => s.SessionId !== SessionId)
      );

    } catch (err) {
      console.error(err);
    } finally {
      setLoadingId(null);
    }
  };

  /* ===========================
     PROCEED AFTER CLEANUP
  =========================== */
  const handleProceed = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/user/verify-otp`,
        { token, otp }
      );

      if (res.data.success) {
        const profile = res.data.data || {};

        localStorage.setItem("token", res.data.realToken);
        if (profile.Role) localStorage.setItem("role", profile.Role);
        if (profile.Email) localStorage.setItem("email", profile.Email);
        if (profile.FullName)
          localStorage.setItem("fullName", profile.FullName);
        if (profile.ProfilePhotoUrl) localStorage.setItem("profilePhotoUrl", profile.ProfilePhotoUrl);
    if (profile.StudentStatus) localStorage.setItem("studentStatus", profile.StudentStatus);
    if (profile.Id) localStorage.setItem("userId", profile.Id);
    
        localStorage.removeItem("tempToken");

        navigate("/", { replace: true });
      }
    } catch (err) {
      console.error("Proceed failed:", err);
    }
  };

  return (
    <div className="min-h-screen px-6 py-10 m-6 ">
      {/* HEADER */}
      <div className="flex items-center gap-0 mb-8 mt-14">
        <img
          src={logo}
          alt="Practical Infosec"
          className=" h-14 w-14"
        />
        <h1 className="mt-2 text-2xl font-bold text-black">
          PRACTICAL INFOSEC
        </h1>
      </div>

      {/* TITLE */}
      <h2 className="mb-2 text-3xl font-semibold text-gray-800">
        Session limit reached
      </h2>

      <p className="mb-8 text-gray-600">
        As per our security policy, you can only log in maximum 2 sessions at
        a time. Please log out of any extra sessions to continue this session.
      </p>

     {/* SESSION TABLE */}
<div className="overflow-hidden bg-white border border-gray-200 shadow-sm rounded-xl">

  {/* TABLE HEADER */}
  <div className="hidden grid-cols-4 px-6 py-4 text-sm font-semibold text-gray-700 bg-gray-100 md:grid">
    <div>Device & OS</div>
    <div>IP Address</div>
    <div>Location</div>
    <div className="text-right">Action</div>
  </div>

  {/* TABLE BODY */}
  {sessionList.map((session) => (
    <div
      key={session.SessionId}
      className="grid items-start grid-cols-1 gap-4 px-6 py-5 border-t md:grid-cols-4 md:items-center"
    >
      {/* DEVICE */}
      <div className="flex flex-col">
        <span className="text-sm font-medium text-gray-900">
          {session.DeviceName}
        </span>
        <span className="text-xs text-gray-500 md:hidden">
          Device & OS
        </span>
      </div>

      {/* IP */}
      <div className="text-sm text-gray-700">
        <span className="block text-xs text-gray-500 md:hidden">
          IP Address
        </span>
        {session.IP}
      </div>

      {/* LOCATION */}
      <div className="text-sm text-gray-700">
        <span className="block text-xs text-gray-500 md:hidden">
          Location
        </span>
        {session.Location}
      </div>

      {/* ACTION */}
      <div className="md:text-right">
        <button
          onClick={() => handleLogoutSession(session.SessionId)}
          disabled={loadingId === session.SessionId}
          className="px-4 py-2 text-sm font-medium text-blue-600 transition border border-blue-200 rounded-md hover:bg-blue-50 disabled:opacity-50"
        >
          {loadingId === session.SessionId
            ? "Logging out..."
            : "Logout Session"}
        </button>
      </div>
    </div>
  ))}
</div>


      {/* PROCEED BUTTON */}
      <div className="flex justify-end mt-8">
        <button
          onClick={handleProceed}
          className="px-6 py-2 text-white transition bg-red-500 rounded-md hover:bg-red-600"
        >
          Proceed
        </button>
      </div>
    </div>
  );
};

export default SessionManagement;
